module.exports = __webpack_public_path__ + "img/foster_icon3.ee8c8bd5.png";